import React from 'react';
import useApp from './useApp';
import DevicesList from './components/devices-list/DevicesList';
import LicensesList from './components/licenses/LicensesList';
import Documentation from './components/documentation/Documentation';
import { Header } from './components/header/Header';
import { ContentWrapper } from './components/ContentWrapper';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useIntl } from '@ysoft/react-intl';
import { Stack } from '@fluentui/react';
import useAuth from './libs/auth';
import { DeviceDetailPage } from './components/port-configuration/DeviceDetailPage';
import Menu from './components/menu/Menu';
import { useConfigContext } from './config/configContext';
import NoAccessPage from './components/NoAccessPage';
import { useUserContext } from './libs/userContext';

const App: React.FC = () => {
	const { classes } = useApp();
	const { t } = useIntl();
	const { isAuthenticated } = useAuth();
	const { config } = useConfigContext();
	const userContext = useUserContext();

	return isAuthenticated ? (
		<div className={classes.appClass}>
			<title>{t('app__title')}</title>
			<header>
				<Header />
			</header>

			<Menu isMobile={true} />

			<Stack horizontal wrap>
				<Stack.Item disableShrink className={classes.navStackItemClass}>
					<Menu isMobile={false} />
				</Stack.Item>
				<Stack.Item className={classes.contentStackItemClass}>
					<ContentWrapper className={classes.wrapperClass}>
						<Routes>
							<Route
								path={'/'}
								element={<Navigate to={'/devices'} replace />}
							/>
							<Route
								path={'/devices/:id'}
								element={<DeviceDetailPage />}
							/>
							<Route
								path={'/devices'}
								element={
									userContext.isSupportUser ? (
										<DevicesList />
									) : (
										<NoAccessPage />
									)
								}
							/>
							{config.licenseToggle && (
								<Route path={'/licenses'} element={<LicensesList />} />
							)}
							<Route path={'/documentation/*'} element={<Documentation />} />
						</Routes>
					</ContentWrapper>
				</Stack.Item>
			</Stack>
		</div>
	) : (
		<div />
	);
};

export default App;
